import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDeviceGroupDocument } from './update.generated';

export const useUpdateDeviceGroup = (
  options: ApiOptions<typeof UpdateDeviceGroupDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateDeviceGroupDocument, {
    ...useNotifications(UpdateDeviceGroupDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_groups.update_success'),
    }),
    ...options,
  });
};
